<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  {{$t('news.template.proposal.split.p1')}}
  <router-link :to="{name: 'ProposalView', params: {id: news.textParams[2]}}">
    {{news.textParams[0]}}
  </router-link>
  {{$t('news.template.proposal.split.p2')}}
  {{news.textParams[1]}}
  {{$t('news.template.proposal.split.p3')}}
</div>
</template>
